(() => {
  if (window.memorraCommerce) return;
  const waitFor = async (resolve, message) => {
    const deadline = Date.now() + 10000;
    while (Date.now() < deadline) {
      const value = resolve();
      if (value) return value;
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    throw new Error(message);
  };
  const notify = error => {
    if (typeof window.showSRSCToastGlobal === 'function') window.showSRSCToastGlobal(error.message);
    else window.alert(error.message);
  };
  const openCart = async () => {
    await waitFor(() => typeof window.slideShiprocketSmartCartInFrame === 'function' && typeof window.updateMiniCartSection === 'function', 'Your cart is still loading. Please try again.');
    window.highestSRCouponApplied = false;
    await window.updateMiniCartSection();
    window.slideShiprocketSmartCartInFrame();
  };
  const fastrrController = () => {
    if (typeof shiprocketCheckoutEvents !== 'undefined' && typeof shiprocketCheckoutEvents.buyCart === 'function') return shiprocketCheckoutEvents;
    if (typeof window.shiprocketCheckoutEvents?.buyCart === 'function') return window.shiprocketCheckoutEvents;
    return null;
  };
  const checkout = async event => {
    const controller = await waitFor(fastrrController, 'Checkout is still loading. Please try again.');
    await controller.buyCart(event);
  };
  window.memorraCommerce = {openCart, checkout};
  window.addEventListener('click', event => {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target.closest?.('a,button,input[type="submit"]');
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    if (target.matches('a[href]')) {
      const url = new URL(target.href, window.location.origin);
      if (url.origin === window.location.origin && /\/(cart)\/?$/.test(url.pathname)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openCart().catch(notify);
        return;
      }
    }
    if (target.matches('#sr-buy-now-button')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkout(event).catch(notify);
      return;
    }
    if (target.matches('[name="checkout"]') && target.closest('form[action*="/cart"],cart-drawer')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      checkout(event).catch(notify);
      return;
    }
    if (target.matches('.breeze-trigger') && target.closest('memorra-checkout')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      target.closest('memorra-checkout').buy(target,event);
      return;
    }
    const form = target.form;
    if (form && target.type === 'submit' && (target.closest('product-form') || target.matches('.mc-add,.mc-purchase button'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.requestSubmit(target);
    }
  }, true);
})();
